/* eslint-disable max-len */
import React from "react";

import emailImage from "../../assets/email.png";

import { Backdrop, ButtonLoader } from "../../kaya";
import { userActions } from "../../actions";

import styles from "./emailConfirmation.module.scss";

// interface Props {
//   visible: boolean;
//   setVisible: (visible: boolean) => void;
//   email: string;
// }

const EmailConfirmation = (props) => {
  const { visible, setVisible, email } = props;

  const [isLoading, setIsLoading] = React.useState(false);

  const handleResend = async () => {
    setIsLoading(true);
    const isSucess = await userActions.resendVerificationEmailAction({
      email,
    });

    setIsLoading(false);
    if (isSucess) {
      setVisible(false);
    }
  };
  return (
    visible && (
      <div>
        <Backdrop visible={visible} setVisible={setVisible} closeOnClick={false} />
        <div className={styles.emailConfirmation}>
          <img src={emailImage} alt="" />
          <p className={styles.confirmation}>Email Confirmation</p>
          {/* <p className={styles.desc}>
            {`We have sent an email to ${email} Please verify \n your email address to go further. Follow the steps shown in the email`}
          </p> */}
          <p className={styles.desc}>
            We have sent an email to{" "}
            <span className={styles.email}>{email}.</span>
            {
              " Please verify \n  your email address to go further. Follow the steps shown in the email"
            }
          </p>
          <p className={styles.question}>
            Don't see the email? Check your spam folder.
          </p>

          <p className={styles.question}>
            <p>Didn’t receive an email?</p>
            {isLoading ? (
              <ButtonLoader active={false} />
            ) : (
              <span className={styles.resent} onClick={handleResend}>
                Resend It
              </span>
            )}
          </p>
        </div>
      </div>
    )
  );
};

export default EmailConfirmation;
